import React from 'react';
import Modal from '../shared/Modal';

class ConfirmModal extends React.Component {
  render() {
    const {
      isOpen,
      closeModal,
      onSubmit,
      heading = 'Do something',
      body = 'Are you sure?',
      cta = 'Okay',
      isAdmin = false
    } = this.props;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className={isAdmin ? 'admin-wrapper' : ''}>
          <h2 className="h2 modal__heading">{heading}</h2>
          <div className="form__row--spacer">
            <div className="modal__p">
              <p className="p">{body}</p>
              {this.props.children}
            </div>
          </div>
          <div className="form__row">
            <div className="form__row-item form__row-item--half">
              <div
                className="btn btn--hollow-blue btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item form__row-item--half">
              <div
                className="btn btn--solid-blue btn--full-width"
                onClick={onSubmit}
              >
                {cta}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/shared/ConfirmModal.js